import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import Icon from 'components/Icon/Icon';

const ReportProject = ({
  onChangeReportComments,
  onChangeReportReason,
  onReport,
  reportComments,
  reportReason,
}) => {
  const maxCommentsLength = 1000;

  return (
    <div className="p++">
      <h3 className="lato-bold text-center mb">Report this project</h3>
      <div className="form-group">
        <label htmlFor="report-reason">Select a reason for your report</label>
        <select
          className="form-control"
          id="report-reason"
          value={reportReason}
          onChange={(event) => onChangeReportReason(event.target.value)}
        >
          <optgroup label="Select a reason for your report">
            <option value="Illegal content">Illegal content</option>
            <option value="Sexually explicit content">
              Sexually explicit content
            </option>
            <option value="Violence/Hate speech">Violence/Hate speech</option>
            <option value="I think this shouldn't be on Twine">
              I think this shouldn't be on Twine
            </option>
            <option value="Spam">Spam</option>
          </optgroup>
        </select>
      </div>
      <div
        className={
          'form-group no-margin' +
          (maxCommentsLength - reportComments.length < 200
            ? ' has-warning'
            : '') +
          (maxCommentsLength - reportComments.length < 100 ? ' has-error' : '')
        }
      >
        <label htmlFor="report-comments">Any additional comments?</label>
        <textarea
          className="form-control"
          id="report-comments"
          maxLength={maxCommentsLength}
          onChange={(event) => onChangeReportComments(event.target.value)}
          placeholder="Please enter as much information as possible, this will help us deal with your report as efficiently as possible."
          rows="4"
          value={reportComments}
        />
        <div
          className="form-control-static text-right no-padding"
          style={{ fontSize: '0.8em' }}
        >
          Characters left: {maxCommentsLength - reportComments.length}
        </div>
      </div>
      <div className="text-center">
        <Button
          bsStyle="primary"
          onClick={() =>
            onReport(
              document.getElementById('report-reason').value,
              document.getElementById('report-comments').value
            )
          }
        >
          <Icon icon="&#xe618;" className="mr-" />
          Submit report
        </Button>
      </div>
      <hr />
      <div className="text-center">
        <p>If you believe this project to be infringing copyrights:</p>
        <Button bsStyle="info" href="/copyright">
          <Icon icon="&#xe618;" className="mr-" />
          Submit copyright report
        </Button>
      </div>
    </div>
  );
};

export default ReportProject;
